import React, { useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import { createIaFeedback } from '../../core/_requests'
import { ID } from '../../../../../../../_metronic/helpers'

type FeedbackModalProps = {
  show: boolean
  onHide: () => void
  videoId: ID
}


export const FeedbackModal: React.FC<FeedbackModalProps> = ({ show, onHide, videoId }) => {
  const [label, setLabel] = useState('Deitado')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await createIaFeedback(videoId, 'position', label);
      onHide()
    } catch (error) {
      console.error('Erro ao enviar feedback:', error)
      alert('Erro ao enviar feedback.')
    } finally {
      setLoading(false)
    }
  }
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Ajustes IA</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formPosition">
            <Form.Label>Posição</Form.Label>
            <Form.Control
              as="select"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            >
              <option value="Deitado">Deitado</option>
              <option value="Em pe">Em pé</option>
              <option value="Sentado">Sentado</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Enviando...
            </>
          ) : (
            'Confirmar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}